import { Card, NoContentBox, useGet } from '@enkla-gui'

import React from 'react'
import { icons } from '@config'
import { tickethelper } from '@/_helpers'
import './ActiveTickets.scss'

export default function ActiveTickets() {
  const { loading: loadingNew, data: newTickets } = useGet({
    endpoint: 'api/ticket',
    filter: { status: 'NEW' }
  })
  const { loading: loadingOpen, data: openTickets } = useGet({
    endpoint: 'api/ticket',
    filter: { status: 'OPEN' }
  })

  const loading = loadingNew || loadingOpen
  const newList = newTickets?.data || []
  const openList = openTickets?.data || []

  // Combine and limit to 5 total
  const allTicketsCombined = [...newList, ...openList]
  const totalTickets = allTicketsCombined.length
  const allTickets = allTicketsCombined.slice(0, 5)
  const hasTickets = allTickets.length > 0
  const hasMoreTickets = totalTickets > 5

  const getStatusStyle = (status) => {
    switch (status) {
      case 'NEW':
        return { icon: 'fa-circle', bgColor: '#e3f2fd', color: '#1565c0' }
      case 'OPEN':
        return { icon: 'fa-clock', bgColor: '#fff3e0', color: '#f57c00' }
      default:
        return { icon: 'fa-ticket-alt', bgColor: '#f5f5f5', color: '#757575' }
    }
  }

  const renderTicket = (ticket) => {
    const style = getStatusStyle(ticket.status)

    return (
      <a key={ticket.id} href={`#!/ticket/${ticket.id}`} className="ticket-item">
        <div className="ticket-icon" style={{ backgroundColor: style.bgColor, color: style.color }}>
          <i className={`fas ${style.icon}`}></i>
        </div>
        <div className="ticket-content">
          {ticket.subject}
        </div>
        <div className="ticket-action">
          <i className="fas fa-arrow-right"></i>
        </div>
      </a>
    )
  }

  return (
    <Card
      title="Pågående Ärenden"
      buttons={{
        header: [{ link: `#!/ticket/status/open`, icon: icons.ticket, text: 'Visa alla detaljer' }]
      }}
      icon={icons.ticket}
      loading={loading}
    >
      {!hasTickets ? (
        <NoContentBox text='Inga ärenden att hantera – allt är under kontroll!' icon='fas fa-check' />
      ) : (
        <>
          <div className="tickets-list">
            {allTickets.map(renderTicket)}
          </div>
          {hasMoreTickets && (
            <div className="tickets-more-indicator">
              <a href="#!/ticket/overview" className="badge bg-info">
                +{totalTickets - 5} fler ärenden
              </a>
            </div>
          )}
        </>
      )}
    </Card>
  )
}
